import { useContext } from 'react';
import './readMoreButtonStyle.css'
import { SelectedLanguageContext } from '../../../contexts/siteContentsContext';

export default function ReadMoreButton({ url, isHeroSection}) {
    const { selectedLanguage } = useContext(SelectedLanguageContext);
    let text = "saiba mais...";

    if (selectedLanguage.name ==='en-us') text = "READ MORE";
    else if (selectedLanguage.name ==='pt-br') text = "SAIBA MAIS";
    if (isHeroSection) text = "CONHEÇA NOSSO MAQUINÁRIO";
    
    return(
        <div className='read-more-button__wrapper'>
            <a href={url} 
                className={isHeroSection ? 
                    'read-more-button__anchor read-more-button__hero-section' 
                    : 
                    'read-more-button__anchor'}
                >
                {text}
            </a>
        </div>
    );
}